import React, {useState} from 'react';
import {PaginationDefaultParams} from "@components/custom/Paginator";
import {RequestData} from '@models/axios';
import {SyntheticEvent} from 'react';

interface SelectionProps {
  count: number;
  data: any[];
  fetchRequest: (requestData: RequestData) => any;
  fetchItemsPickerDataSuccess: (requestData: RequestData) => any;
  location: object;
  type: string
}


interface Options {
  fetchRequest: (requestData: RequestData) => any;
  paginationOnScroll: false,
  initialFetch: true
}

const initialState = {
  currentPage: 1,
  isFetched: false,
  data: [],
  meta: {},
  count: 0,
  filter: {},
  paginationParams : PaginationDefaultParams
};


const whitListData = <P extends object>(Component: React.ComponentType<P>, options: Options) =>{
  return (props) => {
    const {innerRef, filter={}, ...rest} = props;
    const {paginationOnScroll, useFilter} = options;
    const [state, setState] = useState(initialState);
    const defaultFilter = !!useFilter ? useFilter() : {};
    const urlParams = props.match ? props.match.params : {}


    const fetchData = (params: object = {}) => {
      const {fetchRequest} = options;
      setState({...state, isFetched: false, data: []});

      fetchRequest({
        params: {
          ...urlParams,
          ...defaultFilter,
          ...state.paginationParams,
          ...props.filter,
          ...params,
        }
      })
        .then((response) => onFetchData(response))
        .catch((err) => {
        console.log(err?.data?.meta?.message);
        setState({...state, isFetched: true, data: []});
        })
    };

    const onFetchData = ({data, meta}) => {
      const {paginationOnScroll} = options;
      setState({
        ...state,
        isFetched: true,
        data: paginationOnScroll ? [...state.data, ...data] : data,
        meta
      })
    };

    const onScroll = (e: SyntheticEvent) => {
      e.persist();
      const {data, count, paginationParams} = state;
      let target = e.target;
      if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
        if (count > data.length) {
          const offset = paginationParams.offset + PaginationDefaultParams.count;
          setState({
            ...state,
            paginationParams: {
              offset: offset,
              count: PaginationDefaultParams.count
            }
          })
        }
      }
    };

    const onDeleteItem = (item_id) => {
      setState({
        ...state,
        data: state.data.filter(item => item.id !== item_id)
      })
    };

    return (
      <Component
        ref={innerRef}
        {...rest}
        // handleSearch={handleSearch}
        // handleChange={handleChange}
        onScroll={onScroll}
        data={state.data}
        count={state.meta.total_count || state.data.length}
        isFetched={state.isFetched}
        onDeleteItem={onDeleteItem}
        initialFetch={"initialFetch" in options ? options.initialFetch : true}
        fetchData={fetchData}/>
    )
  }
}

export default whitListData;
